import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Modal, Tag as AntdTag, Tooltip } from 'antd'
import { ShowAllTagsButton, Tag, Wrapper } from './NormalTagStyled'
import { inject, observer } from 'mobx-react'
import { toJS } from 'mobx'

const NormalTag = ({
  tags = [],
  commonStore,
  noHover,
  showFullTag = false,
  modalTitle = 'Danh sách người theo dõi',
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false)

  const mouseY = toJS(commonStore?.mouseCordinate?.y) || 0
  const mouseX = toJS(commonStore?.mouseCordinate?.x) || 0
  const isBottomHalf =
    typeof window !== 'undefined' &&
    mouseY > (window.innerHeight ? window.innerHeight / 2 : 400)

  return (
    <>
      <Wrapper noHover={noHover}>
        {showFullTag
          ? tags.map((tag, i) => (
              <Tag key={i} color="blue">
                {tag}
              </Tag>
            ))
          : tags.slice(0, 2).map((tag, i) => (
              <Tag key={i} color="blue">
                {tag}
              </Tag>
            ))}
        {showFullTag ? null : tags.length <= 2 ? null : (
          <Tooltip title={`Xem tất cả (${tags.length})`} placement="top">
            <ShowAllTagsButton
              onClick={e => {
                e.stopPropagation()
                setIsModalVisible(true)
              }}
              onMouseMove={e => commonStore?.setMouseCordinate(e)}>
              ...
            </ShowAllTagsButton>
          </Tooltip>
        )}
        <div
          className="tag-wrapper"
          style={{
            left: Math.max(
              10,
              Math.min(
                mouseX,
                typeof window !== 'undefined' ? window.innerWidth - 300 : 800
              )
            ),
            top: isBottomHalf ? 'auto' : mouseY + 12,
            bottom: isBottomHalf
              ? typeof window !== 'undefined'
                ? window.innerHeight - mouseY + 12
                : 200
              : 'auto',
          }}>
          {tags.slice(2).map((tag, i) => (
            <Tag key={i} color="blue">
              {tag}
            </Tag>
          ))}
        </div>
      </Wrapper>

      <Modal
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ fontSize: 16, fontWeight: 600 }}>{modalTitle}</span>
            <span
              style={{
                fontSize: 13,
                color: '#8c8c8c',
                fontWeight: 'normal',
              }}>
              ({tags.length})
            </span>
          </div>
        }
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        width={560}
        centered
        destroyOnClose>
        <div
          style={{
            maxHeight: 420,
            overflowY: 'auto',
            display: 'flex',
            flexWrap: 'wrap',
            gap: 8,
            padding: '12px 4px',
          }}>
          {tags.map((tag, i) => (
            <AntdTag
              key={i}
              color="blue"
              style={{
                borderRadius: 6,
                fontSize: 13,
                padding: '4px 10px',
                margin: 0,
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                lineHeight: 1.5,
                height: 'auto',
              }}>
              {tag}
            </AntdTag>
          ))}
        </div>
      </Modal>
    </>
  )
}

NormalTag.propTypes = {
  tags: PropTypes.array,
  modalTitle: PropTypes.string,
}

export default inject('commonStore')(observer(NormalTag))
